export {
  COMPACT_INLINE_LINK_CLASS as INLINE_LINK_CLASS,
  COMPACT_PRODUCT_GRID_CLASS as PRODUCT_GRID_CLASS,
  COMPACT_PRODUCT_ROW_CLASS as PRODUCT_ROW_CLASS,
  COMPACT_ROW_MAX_CARDS as PRODUCT_ROW_MAX_CARDS,
  COMPACT_SECTION_TITLE_CLASS as SECTION_TITLE_CLASS,
} from '~/components/CategoryBlocks/Compact/constants';

/**
 * Pulls a DubaiExpress marketplace page up to the header edge. The shared
 * layout reserves a gap above every page (`--layout-content-top`), while the
 * mockup starts its pages right under the header, past the strip the header
 * overlaps (`--layout-header-overlap`).
 */
export const PAGE_TOP_CLASS =
  'mt-[calc(var(--layout-header-overlap,0px)-var(--layout-content-top,0px))]';

/**
 * Top offset of the sticky side columns (catalog facets, product buy panel):
 * 36px under the header, as in the mockup. The desktop page scrolls inside
 * `#content`, whose top padding counts into a sticky offset, so the reserved
 * gap is taken off and the strip under the header overlap is added back.
 */
export const STICKY_COLUMN_TOP_CLASS =
  'top-[calc(var(--layout-header-overlap,0px)+36px-var(--layout-content-top,0px))]';

/**
 * Height cap of a sticky side column that scrolls on its own: the viewport
 * less the 112px above it (header and the gap under it) and 24px below.
 */
export const STICKY_COLUMN_MAX_HEIGHT_CLASS = 'max-h-[calc(100vh-136px)]';
